import {
  Address,
  SearchContactsBody,
  SearchContactsResult,
} from '@this+that/models';
import log from 'loglevel';

import { createApiWithAuth } from '../utils/axios';

export type { SearchContactsResult } from '@this+that/models';

const SEARCH_PATH = '/contacts/search';

let contactsApi: ReturnType<typeof createApiWithAuth> | null = null;

const getContactsApi = () => {
  if (!contactsApi) {
    const baseUrl = import.meta.env.VITE_LOAD_CONTACTS_BASE_URL;
    if (!baseUrl) {
      throw new Error('Contacts base URL is not set');
    }
    contactsApi = createApiWithAuth(baseUrl);
  }
  return contactsApi;
};

const buildAddressLabel = (name: string, email: string): string =>
  name && name !== email ? `${name} <${email}>` : email;

export const userContactToAddress = (
  contact: SearchContactsResult,
): Address | null => {
  if (!contact.email) {
    return null;
  }
  return {
    value: contact.email,
    label: buildAddressLabel(contact.name, contact.email),
  };
};

export const searchContacts = async ({
  input,
  sources,
  platformAccountId,
  requireEmail,
}: SearchContactsBody): Promise<SearchContactsResult[]> => {
  const trimmed = input.trim();
  if (!trimmed) {
    return [];
  }

  try {
    const payload: SearchContactsBody = { input: trimmed };
    if (sources?.length) {
      payload.sources = sources;
    }
    if (platformAccountId) {
      payload.platformAccountId = platformAccountId;
    }
    if (requireEmail) {
      payload.requireEmail = true;
    }

    const { data } = await getContactsApi().post<{
      statusCode: number;
      message: SearchContactsResult[];
    }>(SEARCH_PATH, payload);
    return data?.message ?? [];
  } catch (error) {
    log.error('Failed to search contacts', error);
    return [];
  }
};
